import React, { useState } from 'react';
import {
  DimensionValue,
  Platform,
  TextInput,
  TextInputProps,
} from 'react-native';

import styles from './blank-text-input.style';
import { useColors, useFont } from '../../hooks';
import ThemedText2 from '../themed-text-2';

interface BlankTextInputProps extends TextInputProps {
  hasErrors?: boolean;
  isComplete?: boolean;
}

export default function BlankTextInput({
  hasErrors = false,
  isComplete = false,
  value = '',
  ...props
}: BlankTextInputProps) {
  const [isFocused, setIsFocused] = useState(false);
  const colors = useColors();
  const fonts = useFont();
  const focusedStyle = isFocused && {
    borderColor: colors.primary,
    color: colors.primary,
  };

  const errorStyle = hasErrors && {
    borderColor: colors.error,
    color: colors.error,
  };

  if (isComplete) {
    return (
      <ThemedText2 type="primary" style={styles.completedText}>
        {value}
      </ThemedText2>
    );
  }

  return (
    <TextInput
      autoCapitalize="none"
      autoCorrect={false}
      style={[
        styles.textInput,
        {
          color: colors.gray,
          borderColor: colors.gray,
          ...fonts.primary.bold,
        },
        Platform.OS === 'web' && {
          width: (0.9 * (value?.length ?? 0) + 'ch') as DimensionValue,
        },
        focusedStyle,
        errorStyle,
      ]}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      value={value}
      {...props}
    />
  );
}
